import { render, staticRenderFns } from "./RrcvPL_List.vue?vue&type=template&id=8c00e2b8"
import script from "./RrcvPL_List.vue?vue&type=script&lang=js"
export * from "./RrcvPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports